export default __webpack_public_path__ + "static/media/img-luiz-vieira.c25440b6.png";